import e from "@dialpad/dialtone-tokens/layered/themes/tokens-137-colors.css?inline";
//#region themes/137.js
var t = { brand: {
	css: e,
	name: "137"
} };
//#endregion
export { t as default };
